// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nD","cardInnerHeading":"nE","toggleWrapperClass":"nF","changeProfile":"nG nF","textWrapperClass":"nH","toggleTextClass":"nI"};